import api from './api';
import type { DashboardData, ReportFilter, ReportData } from '../types';

export const dashboardService = {
  async getDashboard(): Promise<DashboardData> {
    const response = await api.get('/dashboard');
    const raw = response.data;
    // Ensure all expected fields have defaults
    return {
      stats: {
        overall_csat: raw?.stats?.overall_csat ?? 0,
        total_clients: raw?.stats?.total_clients ?? 0,
        active_projects: raw?.stats?.active_projects ?? 0,
        pending_surveys: raw?.stats?.pending_surveys ?? 0,
        response_rate: raw?.stats?.response_rate ?? 0,
        csat_trend: raw?.stats?.csat_trend ?? 0,
      },
      csat_trend: raw?.csat_trend ?? [],
      top_clients: raw?.top_clients ?? [],
      bottom_clients: raw?.bottom_clients ?? [],
      alerts: raw?.alerts ?? [],
      recent_responses: raw?.recent_responses ?? [],
    };
  },

  async getReport(filters: ReportFilter): Promise<ReportData> {
    const response = await api.post('/reports/generate', filters);
    const raw = response.data;
    // Normalize report data to match expected shape
    return {
      overall_csat: raw?.overall_csat ?? 0,
      total_responses: raw?.total_responses ?? 0,
      response_rate: raw?.response_rate ?? 0,
      response_count: raw?.response_count ?? raw?.total_responses ?? 0,
      period: raw?.period ?? '',
      csat_trend: raw?.csat_trend ?? [],
      response_rate_trend: raw?.response_rate_trend ?? [],
      client_comparison: raw?.client_comparison ?? [],
      client_breakdown: raw?.client_breakdown ?? [],
      trend_data: raw?.trend_data ?? raw?.csat_trend ?? [],
    };
  },

  async exportReport(filters: ReportFilter, format: 'pdf' | 'csv' | 'xlsx'): Promise<Blob> {
    const response = await api.post(`/reports/export/${format}`, filters, {
      responseType: 'blob',
    });
    return response.data;
  },
};
